const ROLE = {
    SUPER_ADMIN: "SUPER_ADMIN",  // Full control - manage other admins, system settings
    ADMIN: "ADMIN",              // Manage users, approve content, handle support
    SUB_ADMIN: "SUB_ADMIN",      // Limited tasks - view stats, moderate comments
    VENDOR: "VENDOR",            // Marketplace seller - own products/orders via /vendor-portal
    GENERAL: "GENERAL"           // Regular user
}

export default ROLE